export default "__VITE_ASSET__DC80rgpS__"